import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NavController } from '@ionic/angular';
import { AppRoutingKeys } from '@shared';

@Component({
	selector: 'app-registration-base',
	template: '',
	styleUrls: []
})
export class AccountBaseComponent implements OnInit {
	public registrationForm: FormGroup;
	public fieldFormControl: FormControl;

	public constructor(
		public navController: NavController,
		public router: Router
	) {}

	public ngOnInit(): void {
		this.fieldFormControl = new FormControl('', [Validators.required]);

		this.registrationForm = new FormGroup({
			fieldFormControl: this.fieldFormControl
		});
	}

	public goBack(): void {
		this.navController.pop();
	}

	/* eslint-disable @typescript-eslint/no-unused-vars */
	public async onSubmit(formValues: { fieldFormControl: string }): Promise<void> {}

	public isRegistration(): boolean {
		return this.router.url.includes(AppRoutingKeys.urlPathRegistration);
	}

	public isFormValid(): boolean {
		return this.registrationForm.valid;
	}
}
